module.exports = __webpack_public_path__ + "static/media/FullScreen.a2627e9c.svg";